import type { ThreadOperationSummaryInput } from "./operationIdentity.ts";
import type { DesignOperationSummary } from "./designOperationSummary.logic.ts";
import { summarizeDesignOperation } from "./designOperationSummary.logic.ts";

/**
 * Which shape stands in for an operation's arranged prompt, or `null` when
 * nothing does and the stored text renders as itself.
 *
 * Design is the only Action with operations. A Brain Action's send is an
 * ordinary turn whose prompt the composer arranged, so its bubble draws that
 * prompt exactly as any other message does.
 */
export type ThreadOperationBubble = {
  readonly kind: "design";
  readonly summary: DesignOperationSummary;
};

export function deriveThreadOperationBubble(
  operation: ThreadOperationSummaryInput,
): ThreadOperationBubble | null {
  const design = summarizeDesignOperation(operation);
  return design === null ? null : { kind: "design", summary: design };
}
